import { render, staticRenderFns } from "./FormGeneratorComponent.vue?vue&type=template&id=1925a7c4&scoped=true&lang=pug"
import script from "./FormGeneratorComponent.vue?vue&type=script&lang=ts"
export * from "./FormGeneratorComponent.vue?vue&type=script&lang=ts"
import style0 from "./FormGeneratorComponent.vue?vue&type=style&index=0&id=1925a7c4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1925a7c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1925a7c4')) {
      api.createRecord('1925a7c4', component.options)
    } else {
      api.reload('1925a7c4', component.options)
    }
    module.hot.accept("./FormGeneratorComponent.vue?vue&type=template&id=1925a7c4&scoped=true&lang=pug", function () {
      api.rerender('1925a7c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/forms/FormGenerator/FormGeneratorComponent.vue"
export default component.exports